@if (companyId === currentCompanyId) {
    <div>{{ companyName }}</div>
} @else {
    <app-descriptive-item
        [text]="companyName"
        [tooltip]="'This information is not updated. You can update it in the menu at the end of this row'"
    ></app-descriptive-item>
}
